angular.module('homebot.directives')
  .directive('directMessage', ['DataService', 'PageNotificationService', 'RollbarService', function (DataService, PageNotificationService, RollbarService){
  return {
    restrict: 'E',
    controllerAs: 'directMessageCtrl',
    bindToController: {
      coRecipientId: '@',
      homeId: '@',
      originalMessage: '@',
      recipientId: '@',
      topic: '@',
      userId: '@',
    },
    replace: true,
    templateUrl: '/homes/templates/partials/direct-message.html',
    scope: { },
    controller: function(){
      let ctrl = this;
      ctrl.message = ctrl.originalMessage || '';

      ctrl.submit = function(){
        let message = _.trim(ctrl.message);

        if(!message) return;

        ctrl.loading = true;

        if(ctrl.recipientId && ctrl.coRecipientId)
          sendSponsorMessage(message);
        else
          sendMessage(message);
      }

      function sendMessage(message){
        const agentId = ctrl.recipientId || ctrl.coRecipientId;

        DataService.sendMessage(ctrl.homeId, ctrl.userId, agentId, message, ctrl.topic)
          .then(onSuccess)
          .catch(onError);
      }

      function sendSponsorMessage(message){
        const args = {
          coRecipientId: ctrl.coRecipientId,
          message,
          recipientId: ctrl.recipientId,
          topic: ctrl.topic,
          userId: ctrl.userId,
        };

        DataService.sendSponsorMessage(ctrl.homeId, args)
          .then(onSuccess)
          .catch(onError);
      }

      function onSuccess() {
        PageNotificationService.success('Message sent!');
        ctrl.loading = false;
        ctrl.message = ctrl.originalMessage || '';
      }

      function onError(e){
        ctrl.loading = false;
        PageNotificationService.error('There was an error sending your message.');
        RollbarService.error('Send Message Error', e);
      }
    },

    link: function($scope, el, attrs){

    }
  };
}]);
